import { InputProps } from '../index';

const normalizeBoolean = (value: any) => {
  if (typeof value === 'boolean') return value;

  if (typeof value === 'string') {
    const normalized = value.trim().toLowerCase();

    if (normalized === 'true' || normalized === '1' || normalized === 'on') {
      return true;
    }

    if (
      normalized === 'false' ||
      normalized === '0' ||
      normalized === 'off' ||
      normalized === ''
    ) {
      return false;
    }
  }

  if (typeof value === 'number') {
    return value === 1;
  }

  return Boolean(value);
};

const normalizeString = (value: string, type?: string) => {
  let normalized = value.trim();

  if (type === 'text') {
    normalized = normalized.replace(/<[^>]*>/g, '');
    normalized = normalized.normalize('NFKC');
    normalized = normalized.trim();
  }

  return normalized;
};

const normalizeValue = (value: any, type?: string): any => {
  if (value == null) return value;

  if (Array.isArray(value)) {
    return value.map(item => normalizeValue(item, type));
  }

  if (type === 'checkbox' || type === 'switch') {
    return normalizeBoolean(value);
  }

  if (typeof value === 'string') {
    return normalizeString(value, type);
  }

  return value;
};

export const normalizeFormData = (
  data: Record<string, any>,
  inputs: InputProps[],
  hiddenInputs?: InputProps[]
) => {
  const normalizedData: Record<string, any> = {};
  const allInputs = [...inputs, ...(hiddenInputs || [])];

  allInputs.forEach(input => {
    normalizedData[input.name] = normalizeValue(data[input.name], input.type);
  });

  return normalizedData;
};
